import { createSelector } from 'reselect';

export const selectEventsSlice = state => state.events;

export const selectEvents = createSelector(
  selectEventsSlice,
  slice => slice.events
);
export const eventsLoaded = createSelector(
  selectEventsSlice,
  slice => slice.eventsLoaded
);
export const selectActiveEvent = createSelector(
  selectEventsSlice,
  slice => slice.activeEvent
);
export const eventCreating = createSelector(
  selectEventsSlice,
  slice => slice.isCreating
);
export const eventsMeta = createSelector(
  selectEventsSlice,
  slice => slice.meta
);
export const eventsFilters = createSelector(
  selectEventsSlice,
  slice => slice.filters
);
